import React from 'react';
// import { Link } from 'react-router-dom'
import { Row, Col, Layout } from 'antd'

import LoginForm from '../../components/LoginForm/LoginForm';
import Footer from '../../components/Footer/Footer';
import classes from './Login.css';
import isNotAuthenticated from '../../utils/isNotAuthenticated';

const { Content } = Layout;

class Login extends React.Component {
  render() {
      return (
          <div style={{ backgroundColor: '#FAFAFA' }}>
              <Layout className={classes.parentContainer}>
                  <Content className={classes.content}>
                      <Row>
                          <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                              <Row type='flex' justify='center'>
                                  <Col className={classes.loginForm}>
                                    <LoginForm />
                                  </Col>
                              </Row>
                          </Col>
                      </Row>
                  </Content>
                  <Footer noAdminLink />
              </Layout>
          </div>
      );
    }
}

export default isNotAuthenticated(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.js